export const COMMENT_REPORT_TYPES = {
  FCA: 'FCA',
  ESMA: 'ESMA',
  FORM_PF: 'FORM_PF'
};

export const COMMENTS_SIDEBAR_EXPANDED_WIDTH = 270;
export const COMMENTS_SIDEBAR_COLLAPSED_WIDTH = 55;

// used to create a comment thread for AIFM, unlike AIF AIFM doesn't have any fundId or fundName
export const COMMENT_CUSTOM_FUND_NAMES = {
  FCA_FUND_NAME: 'AIFM_FCA_UK',
  ESMA_FUND_NAME: 'AIFM_ESMA',
  FORM_PF_FUND_NAME: 'AIFM_FORM_PF'
};
